import { MoonLoader } from "react-spinners";

export default function Spinner() {
  return (
    <div className=" d-flex justify-content-center align-items-center my-4">
      <MoonLoader size={100} color="#006400" />
    </div>
  );
}
